const resource = 'questions'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}`, { params })
  },
  fetchHome() {
    return $axios.$get('/v2/home-questions')
  },
  fetchVehicleSearchPageQuestions(vehicleId) {
    return $axios.$get(`/v2/vehicle-search-page/${vehicleId}/questions`)
  },

  getServiceName: name => 'questionService',
})
